import { createFileRoute, redirect } from '@tanstack/react-router'
import { subaccountsQuery } from '@/lib/queries'

/**
 * There is no separate account-level topics page — topics live and are edited in a sub-account's
 * workspace, so `/topics` just forwards to the account's primary (main) sub-account. Everything the
 * old overview offered (copying a topic to another sub-account, seeing what's inherited from
 * elsewhere) now lives in that workspace. The redirect keeps every existing link to `/topics`
 * working: the sidebar nav, the account home, the "All clients" switcher entry.
 */
export const Route = createFileRoute('/app/accounts/$accountId_/topics/')({
  loader: async ({ context, params }) => {
    const { subaccounts } = await context.queryClient.ensureQueryData(
      subaccountsQuery(params.accountId),
    )
    const target = subaccounts.find((sub) => sub.isPrimary) ?? subaccounts[0]
    // Every account has at least one sub-account, so `target` is effectively always set; the guard is
    // only for the impossible empty case, where there is genuinely nowhere to send anyone.
    if (target) {
      throw redirect({
        to: '/app/accounts/$accountId/topics/$subaccountId',
        params: { accountId: params.accountId, subaccountId: target.id },
      })
    }
  },
  component: () => null,
})
